export default __webpack_public_path__ + "static/media/Subirgrismin.8a420917.svg";